/**
 * Indicators and favourite indicators in the saved chart settings (TV-14).
 * The engine checks the inputs and styles itself (normalizeInputs, mergeStyles),
 * here only the shape is checked, so a broken value never reaches it.
 */

export const isPlainObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

const parseIndicator = (value) => {
  if (!isPlainObject(value) || typeof value.id !== "string" || !value.id) return null;

  return {
    id: value.id,
    inputs: isPlainObject(value.inputs) ? value.inputs : {},
    styles: isPlainObject(value.styles) ? value.styles : {},
    isVisible: value.isVisible !== false,
  };
};

/**
 * @param {*} value - parsed from localStorage
 * @returns {Array<{ id: string, inputs: object, styles: object, isVisible: boolean }>}
 *   in the order they were added; an empty list for anything else
 */
export const parseSavedIndicators = (value) =>
  Array.isArray(value) ? value.map(parseIndicator).filter(Boolean) : [];

/**
 * @param {*} value - parsed from localStorage
 * @returns {string[]} registry ids of the favourite indicators
 */
export const parseFavoriteIndicators = (value) =>
  Array.isArray(value) ? value.filter((id) => typeof id === "string" && id) : [];

/**
 * What the chart settings keep of an indicator of the engine list.
 *
 * @param {{ id: string, inputs: object, styles: object, isVisible: boolean }} indicator - engine.getIndicators() item
 * @returns {{ id: string, inputs: object, styles: object, isVisible: boolean }}
 */
export const toSavedIndicator = ({ id, inputs, styles, isVisible }) => ({ id, inputs, styles, isVisible });
